import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RoleGroupPickerComponent } from './role-group-picker.component';

@NgModule({
  imports: [CommonModule],
  declarations: [RoleGroupPickerComponent],
  exports: [RoleGroupPickerComponent],
})
export class SharedRoleGroupPickerModule {}
